
view.scaling = window.innerWidth < 480 ? 
new Point(.1,.1) : new Point(.2,.2);

function grid(x,y,size){
    var columns = [];
    var groups = [];
    var offset = Math.floor(Math.random()*1536)
    width = window.innerWidth/x;
    height = window.innerHeight/y;
    if(size!==undefined){
      width = size;
      height = size;
      x = Math.ceil(window.innerWidth/size);
      y = Math.ceil(window.innerHeight/size);
    }
    for(var i=0;i<x;i++){
      columns[i] = [];
      groups[i] = new paper.Group();
      for(var j=0;j<y;j++){
        columns[i][j] = new paper.Path.Rectangle(i*width,j*height,width,height);
        // columns[i][j].fillColor = colorWheel(offset+((i*j)/(x*y)*1536));//prettyRaCo();
        //columns[i][j].scale(2)
        groups[i].children.push(columns[i][j]);
        }
      //groups[i].scale(3);
  
    }
    this.columns = columns;
    return groups;
  }
  
  function hashCode(str) {
    return Array.from(str).reduce((hash, char) => 0 | (31 * hash + char.charCodeAt(0)), 0)
  }
  
  var randomSeed = new Mash();
  let seedBase = hashCode(navigator.userAgent.toString());
  console.log("SEED BASE!",hashCode("hiii"),(navigator.userAgent))
  let drawingId = 1;
  let seed = `${seedBase}-${drawingId}`;
  
  function shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }
  
  function num(range){
      // return Math.floor(randomSeed("yo")*range)
    return Math.floor(randomSeed(seed)*range);
  }
  
  
  function random(){
      // return Math.floor(randomSeed("yo")*range)
    return randomSeed(seed);
  }
  
  
  function prettyRaCo(){
    var colorWheel =  Math.floor(random()*6);
  
    var color = "rgb(";
    var randomNumber =  Math.floor(random()*256);
    if(colorWheel ==0)
    color= color+ "0,255,"+randomNumber+")";
     if(colorWheel ==1)
    color= color+ "0,"+randomNumber+",255)";
     if(colorWheel ==2)
    color= color+ "255, 0,"+randomNumber+")";
     if(colorWheel ==3)
    color= color+ "255,"+randomNumber+",0)";
     if(colorWheel ==4)
    color= color+ randomNumber+",255,0)";
     if(colorWheel ==5)
    color= color+ randomNumber+",0,255)";
    return color;
  }
  function colorWheel(entry){
    var key;
    if(entry<0)
      entry = 1535-(-entry%1535);
    else
      entry = entry%1535;
  
    var text = "rgb(";
    var num = entry%256;
    if(entry >= 0 && entry < 256)
      text= text+ "0,255,"+num+")";
    else if(entry>255 && entry<512)
      text= text+ "0,"+(255-num)+",255)";
    else if(entry>511 && entry<768)
            text= text+ num +",0,255)";
    else if(entry>767 && entry<1024)
      text= text+ "255,0,"+(255-num)+")";
    else if(entry>1023 && entry<1280)
      text= text+ "255,"+num+",0)";
    else if(entry>1279 && entry<1535)
      text= text+ (255-num)+",255,0)";
    return text;
  }
  
  let guides = new Group();
  function sketch(){
    project.activeLayer.clear()
    var g = grid(0,0,Math.min(window.innerWidth,window.innerHeight)/3.5)
    var all = new Group();
    g.map(function(e){
      e.children.map(function(f){
        all.children.push(f)
      })
    })
  
    guides.children.push(g);
  
    var children = all.children.slice();
    shuffle(children)
    var segments = new Group();
    var path = new Path({strokeColor: "black"});
    path.add(children[0].position)
    // path.closed = true;
    segments.children.push(path);
    for (var i = 1; i < children.length-2; i+=2) {
      var success = false; 
      while(!success){
        try {
          path[["curveTo","add","curveTo","add"][num(4)]](children[i+1].position,children[i].position)
          success = true;
        } catch (error) {
          
        }
      }
      if(random()<.5){
        path.remove();
        path = new Path();
        path.strokeColor = "black"
        i+=2
        if(children[i+1]){
          path.add(children[i+1].position); 
        }
        segments.children.push(path);
        path.remove();
      }
    }
    segments.fitBounds(view.bounds)
    segments.scale(.75)
    return segments;
  }
  
  function clearGuides(){
  
    guides.children.map((ch)=> {
      if(ch && ch.remove)
      ch.remove()
    });
    guides.remove();
    return;
    guides.children.forEach(function(ch){ 
      if(ch.children){
        ch.clearChildren();
      } else {
        console.log(ch)
        ch.remove();
      }
    })
  }
  
  let text;
  
  function draw() {
    randomSeed = new Mash()
    seed = `${seedBase}-${drawingId}`;
    var ps = sketch();
    ps.children.map(pathToFingertrap);
    // clearGuides();
    ps.remove();
  }
  
  function onMouseDown(){
    drawingId = Math.min(100, drawingId + 1);
   draw();
  }
  
  function idUp(){
    drawingId = Math.min(100, drawingId + 1);
  }
  
  function idDown(){
    drawingId = Math.max(1, drawingId - 1);
  }
  
  function downloadAsSVG(fileName) {
  
    if(!fileName) {
        fileName = seed+".svg"
    }
    //console.log(paper.project.exportSVG({asString:true}))
    var url = "data:image/svg+xml;utf8," + encodeURIComponent(paper.project.exportSVG({asString:true}));
  
    var link = document.createElement("a");
    link.download = fileName;
    link.href = url;
    link.click();
  }
  
  function onKeyDown(event) {
    
    if(event.key === "left"){
      idDown();
      draw();
    }
    if(event.key === "right"){
      idUp();
      draw();
    }
    if(event.key==="d"){
      downloadAsSVG();
    }
  }
  
  draw();
  
  function pathToFingertrap(path){
    var paths = new Group();
    
    var colorOffset = num(1536);
    var colorSkip = 1+num(50)
    var pathCount = 40+num(40);
    var radius = 10+num(60);
    var rotation = num(200)/100;
  
    var circle = new Path.Circle(path.getPointAt(0),radius)
    for (var index = 0; index < pathCount; index++) {
      var p = new Path();
      p.strokeColor = colorWheel(colorOffset);
      colorOffset += colorSkip;
      p.strokeWidth = 1;
      paths.children.push(p)
    }
    for (var index = 0; index < path.length; index+= 10) {
      var pt = path.getPointAt(index);
      circle.position = pt;
      circle.rotate(rotation)
      for (var i = 0; i < pathCount; i++) {
        paths.children[i].add(circle.getPointAt(i*(circle.length/pathCount)))
      }
      for (var i = 0; i < pathCount; i++) {
        // paths.children[i].smooth();
      }
    }
  }
  